import createReactComponent from '../createReactComponent';
var CreditCard = createReactComponent('CreditCard', [['rect', {
  x: '1',
  y: '4',
  width: '22',
  height: '16',
  rx: '2',
  ry: '2',
  key: '11q156'
}], ['line', {
  x1: '1',
  y1: '10',
  x2: '23',
  y2: '10',
  key: '1augj8'
}]]);
export default CreditCard;